import type { Options } from 'ky';

import { getSIWENonce } from '@api/user';

import type { ApiOptions} from './api';
import { mergeKyRequestHeaders } from './api';

export type ApiCall<O extends Options, R = void> = (options: ApiOptions<O>) => Promise<R>;

export const protectedByNonce = <C extends ApiCall<any, any>>(call: C) => {
  return async ({ headers, ...restOptions }: ApiOptions<Parameters<C>[0]>) => {
    const nonce = await getSIWENonce({});

    return call({
      ...restOptions,
      headers: mergeKyRequestHeaders(headers, {
        Nonce: nonce,
      }),
    });
  };
};
